import React, {useState} from 'react'
import compose from 'recompose/compose'
import * as S from './styled'
import {withI18n} from '../../hocs'
import {
  // CheckButton,
  DateInput, InputEditor, InputField} from '../../atoms'
import _ from "lodash";
import {AlertDialog} from "../index";
import ActionDialog from '../action-dialog'
import {useAppContext} from "../../../context/appContext";
import {getCurrentSectionKey, SECTION_KEYS} from "../../../config/constants";
import {useParams} from "react-router";
import * as FiltersUtils from "../../../utils/filters"

const OfferInboxButton = ({ ids, i18n, postOffer, filtersValues, totalRows,
                            // , sms
}) => {

  const {savedSearchItemId} = useParams();
  const {filters, savedSearchItems, filterGroup} = useAppContext();

  if (ids && ids.length > 0) {
    filtersValues = {'candidature_id' : ids}
  }

  const [open, setOpen ] = useState(false)
  const [areUSure, setAreUSure ] = useState(false)
  const [formData, setFormData] = React.useState({name:'', description:'', dateFrom: null, dateTo: null, smsNotification: false})

  const handleSubmit = e => {
    e.preventDefault()
    if (!isValid()) {
      return
    }
    if (!areUSure) {
      setAreUSure(true)
      return
    }

    let filtersForOffer = {}
    let terminateEval = false;
    if (ids && ids.length > 0) {
      terminateEval = true;
      filtersForOffer = {'candidature_id': ids};
    }
    if (!terminateEval && Object.keys(filtersValues) > 0) {
      terminateEval = true;
      filtersForOffer = filtersValues;
    }
    if (!terminateEval && getCurrentSectionKey() !== SECTION_KEYS.SAVED_SEARCHES_ITEM) {
      terminateEval = true;
      filtersForOffer = filters[getCurrentSectionKey()];
    }

    if (!terminateEval) {
      let strFilters = savedSearchItems && savedSearchItems[savedSearchItemId] ? savedSearchItems[savedSearchItemId].fields : null;
      let filters = strFilters ? JSON.parse(strFilters) : {};
      let filterGroupValue = filterGroup[getCurrentSectionKey()] && filterGroup[getCurrentSectionKey()][savedSearchItemId] ? filterGroup[getCurrentSectionKey()][savedSearchItemId] : null;

        filtersForOffer = FiltersUtils.refactorSavedSearchFiltersByGroupSelected(filters, filterGroupValue);
    }

    // Devuelve la promesa: spinner en la confirmación y los modales se cierran cuando responde bien
    /* eslint-disable no-useless-computed-key */
    return postOffer({...formData, ['filters']: filtersForOffer} ).then(() => {
      setAreUSure(false)
      setOpen(false)
      setFormData({name:'', description:'', dateFrom: null, dateTo: null, smsNotification: false})
    })
  }

  const isValid = () => {
    return !_.isEmpty(formData.name)
      && !_.isEmpty(formData.description)
      && !_.isEmpty(formData.dateFrom)
      && !_.isEmpty(formData.dateTo)
  }

  return (
    <>
      <ActionDialog
        open={open}
        title={i18n.offerModal.title}
        onClose={()=>setOpen(false)}
        onConfirm={handleSubmit}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={i18n.modalMailCustom.send}
        confirmDisabled={!isValid()}
        disableBackdropClose
      >
        <S.ModalStyled>
          <form onSubmit={handleSubmit}>
            <div className="form-field">
              <label>{i18n.offerModal.name}</label>
              <InputField
                fontSize="small"
                placeholder={i18n.offerModal.name_placeholder}
                name="name"
                value={formData.name}
                required="true"
                handleOnChange={value => {
                  /* eslint-disable no-useless-computed-key */
                  setFormData({...formData, ['name']: value })
                }}
              />
            </div>
            <div className="form-field">
              <label>{i18n.offerModal.description}</label>
              <InputEditor
                fontSize="small"
                placeholder={i18n.offerModal.description_placeholder}
                name="message"
                value={formData.description}
                required="true"
                onChange={value => {
                  /* eslint-disable no-useless-computed-key */
                  setFormData({...formData, ['description']: value })
                }}
              />
            </div>
            <div className="form-field">
              <label>{i18n.offerModal.date_range}</label>
              <DateInput
                value={{from: formData.dateFrom, to: formData.dateTo}}
                format="DD/MM/YYYY"
                placeholder={i18n.modalFilter.fromDate}
                required="true"
                onChange={(value) =>
                  /* eslint-disable no-useless-computed-key */
                  setFormData({...formData, ['dateFrom']: value.from, ['dateTo']: value.to, })}
                range
              />
            </div>

          {/*
            {sms && (
              <Grid container spacing={3} alignItems="center" className="sms">
                <Grid item>
                  <TelIcon />
                </Grid>
                <Grid>
                  <label>Sms </label>
                </Grid>
                <Grid className="box-check">
                  <CheckButton name="sms" title="" checked={formData.smsNotification} onChange={() =>
                    // eslint-disable no-useless-computed-key
                    setFormData({...formData, ['smsNotification']: !formData.smsNotification })} />
                </Grid>
              </Grid>
            )}*/}

            <AlertDialog
              open={areUSure}
              onClose={() => setAreUSure(false)}
              onSuccess={(e) => handleSubmit(e)}
              title={i18n.process.deleteModalTitle}
              text={i18n.offerModal.areUSure.description.replaceAll('{num}', (ids && ids.length > 0) ? ids.length : totalRows)}
            />
          </form>
        </S.ModalStyled>
      </ActionDialog>
      <S.ButtonExport
        variant="contained"
        color="secondary"
        onClick={() => setOpen(true)}
      >
        {i18n.processesTable.offer} ({(ids && ids.length > 0) ? ids.length : i18n.processesTable.all})
      </S.ButtonExport>
    </>
  )
}

const enharce = compose(withI18n)

export default enharce(OfferInboxButton)